
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10 1a9 9 0 00-9 9v24.837a9 9 0 009 9h24.837a9 9 0 009-9V10a9 9 0 00-9-9H10z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M30.39 26.073c.32 0 .58.26.58.58a6.356 6.356 0 01-5.544 6.297.58.58 0 01-.146-1.15 5.196 5.196 0 004.499-4.567l-15.587-.002a5.196 5.196 0 005.155 4.608h3.11a.58.58 0 010 1.16V33h-3.11A6.355 6.355 0 0113 26.652c0-.32.26-.58.58-.58h16.81zm-4.76-3.48a.58.58 0 010 1.16H14.45a.29.29 0 000 .58H29.52a.29.29 0 000-.58h-.993a.58.58 0 010-1.16h.993a1.45 1.45 0 010 2.898l-15.071.001c-.8 0-1.45-.65-1.45-1.45 0-.798.65-1.448 1.45-1.448h11.18zm4.76-1.738a.58.58 0 010 1.159H13.58a.58.58 0 010-1.16h16.81zM20.52 11a.58.58 0 010 1.16h-.216a6.152 6.152 0 00-6.145 6.144v.812h15.652v-.812a6.152 6.152 0 00-6.145-6.145h-.248a.58.58 0 010-1.159h.248c4.028 0 7.304 3.276 7.304 7.304v1.391a.58.58 0 01-.58.58H13.58a.58.58 0 01-.58-.58v-1.391C13 14.276 16.276 11 20.304 11h.216zm1.755 6.348a.58.58 0 110 1.16.58.58 0 010-1.16zm-2.898-.58a.58.58 0 110 1.16.58.58 0 010-1.16zm5.797 0a.58.58 0 110 1.16.58.58 0 010-1.16zm2.898-.579a.58.58 0 110 1.16.58.58 0 010-1.16zm-11.594-.58a.58.58 0 110 1.16.58.58 0 010-1.16zm7.536-1.739a.58.58 0 110 1.16.58.58 0 010-1.16zm-4.058-.58a.58.58 0 110 1.16.58.58 0 010-1.16z","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    